import { RMTypePaybleEnum } from "libs/shared-models/common-models/src/lib/enum/rm-type-payble-enum"

export class PayableRequest {
    invoiceId?:number
    invoiceType?:string
    quantity?:number
    amount?:number
    deduction?:number
    finalAmount?:number
    payment?:number
    createdUser?:string
    vendorId?:number
    receivedDate?:string|Date
    invoiceNumber?:string
    item?:string
    tdsApplicable?:boolean
    due?:number
    invoiceDate?:string|Date
    remarks?:string
    rmType?:RMTypePaybleEnum
    taxId?:number
    taxAmount?:number
    dutyPercentage?:number
    dutyAmount?:number
    invoiceAmount?:number
    transactionType?:string
    currency?:number
    exchangeRate?:number
    receivedAmountInr?:number
    bankAccount?:number
    bankCharges?:number
    buyerShortPayment?:number

    constructor(
        invoiceId?:number,
    invoiceType?:string,
    quantity?:number,
    amount?:number,
    deduction?:number,
    finalAmount?:number,
    payment?:number,
    createdUser?:string,
    vendorId?:number,
    receivedDate?:Date,
    invoiceNumber?:string,
    item?:string,
    tdsApplicable?:boolean,
     due?:number,
     invoiceDate?:Date,
     remarks?:string,
     rmType?:RMTypePaybleEnum,
     taxId?:number,
     taxAmount?:number,
     dutyPercentage?:number,
     dutyAmount?:number,
     invoiceAmount?:number,
     transactionType?:string,
    currency?:number,
    exchangeRate?:number,
    receivedAmountInr?:number,
    bankAccount?:number,
    bankCharges?:number,
    buyerShortPayment?:number,

    ){
        this.amount =amount
        this.createdUser = createdUser
        this.deduction =deduction 
        this.finalAmount = finalAmount
        this.invoiceId = invoiceId
        this.invoiceType = invoiceType
        this.vendorId = vendorId
        this.receivedDate = receivedDate
        this.payment = payment
        this.quantity = quantity
        this.invoiceNumber = invoiceNumber
        this.item = item
        this.tdsApplicable = tdsApplicable
        this.due = due
        this.invoiceDate = invoiceDate
        this.remarks = remarks
        this.rmType = rmType
        this.taxId = taxId
        this.taxAmount = taxAmount
        this.dutyPercentage = dutyPercentage
        this.dutyAmount = dutyAmount
        this.invoiceAmount = invoiceAmount
        this.transactionType = transactionType
        this.currency = currency
        this.exchangeRate = exchangeRate
        this.receivedAmountInr = receivedAmountInr
        this.bankAccount = bankAccount
        this.bankCharges = bankCharges
        this.buyerShortPayment = buyerShortPayment

    }
}
export class PayableFilterRequest{
    type?:string
    invoiceNumber?:string
    invoiceFromDate?:string
    invoiceToDate?:string
    receivedFromDate?:string
    receivedToDate?:string
    supplierId?:number
    unit?:string
    rmType?:string
    constructor(
        type?:string,
    invoiceNumber?:string,
   invoiceFromDate?:string,
    invoiceToDate?:string,
    receivedFromDate?:string,
    receivedToDate?:string,
    supplierId?:number,
    unit?:string,
    rmType?:string
    )
{
    this.invoiceFromDate = invoiceFromDate
    this.invoiceNumber = invoiceNumber
    this.receivedFromDate = receivedFromDate
    this.supplierId= supplierId
    this.type = type =type
    this.invoiceToDate = invoiceToDate
    this.receivedToDate = receivedToDate
    this.unit= unit
    this.rmType = rmType

}
}